import slugify from 'slugify';

export const HubSectionTitle = ({ children }: { children: string }) => {
  return (
    <h2
      className="font-semibold text-2xl text-gray"
      id={slugify(children, {
        lower: true,
        strict: true,
      })}
    >
      {children}
    </h2>
  );
};
